import React from 'react'
import GoogleLogin from 'react-google-login'

import { Form, Input, Button, message, Spin, Checkbox} from 'antd'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import queryString from 'query-string'

import { login, new_login, mfa_respond, refresh_profile, LOGIN_SUCCESS } from '../../../actions/auth'

import EnvelopeImg from '../../../assets/img/envelope.png'
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import { receiveData } from '../../../api/http'

import wasabiDarkLogo from '../../../assets/logo/cloudflyer-logo-header.png';

import './styles.scss'

class Login extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            submitted: false,
            referrer_id: null,
            auth_loading: false,
            forgotPasswordVisible: false,
            emailSentVisible: false,
            email: '',
            sendingRequest: false,
        }

        // CloudFlyerAPI.user_account.logout()
        CloudFlyerAPI.new_user_account.logout()
    }
    
    componentDidMount() {
        let { referrer_id, returnUrl } = queryString.parse(this.props.location.search) || {}
        this.setState(
            {
                loading: false,
                referrer_id: referrer_id ? referrer_id : undefined,
                returnUrl: returnUrl ? returnUrl : undefined,
            },
            () => CloudFlyerAPI.new_user_account.logout
        )
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.loginErrors && this.state.submitted) {
            message.error(nextProps.loginErrors)
            this.setState({ submitted: false })
        }
        if (
            !nextProps.error &&
            nextProps.user 
            // nextProps.user.first_name &&
            // localStorage.Authorization
        ) {
            // message.success(
            //     'Welcome ' 
            //         // nextProps.user.first_name +
            //         // ' ' +
            //         // nextProps.user.last_name
            // )
            this.props.history.replace(this.state.returnUrl || '/')
        }

        this.setState({
            loading: nextProps.loading,
        })
    }

    handleSubmit = (e) => {
        this.setState({
            loading: true
        })

        e.preventDefault()
        let $this = this;
        CloudFlyerAPI.new_user_account.request_temp_token()
        .then(function (response) {
            $this.setState({
                submitted: true
            })
            let token = (response||{}).data;
            const { user, password } = $this.props.form.getFieldsValue()
            let userType = 12;
            $this.props.new_login(token, user, password, userType);
        })
        .catch(function (err) {
            console.log(err);
        })
    }

    handleMFASubmit = (e) => {
        this.setState({
            loading: true
        })

        e.preventDefault()
        let $this = this;
        CloudFlyerAPI.new_user_account.request_temp_token()
        .then(function (response) {
            $this.setState({
                submitted: true
            })
            let token = (response||{}).data;
            const { mfacode } = $this.props.form.getFieldsValue()
            let userType = 12;
            $this.props.mfa_respond(token, mfacode, $this.props.mfaSession);
        })
        .catch(function (err) {
            console.log(err);
        })
    }
    

    // this.props.request_token(user, password, token);
    toRegister = () => {
        let path =
            this.state.referrer_id !== undefined
                ? '/?referrer_id=' + this.state.referrer_id
                : ''
        this.props.history.replace('/signup' + path)
    }

    handleOktaLogin() {
        let path =
            this.state.referrer_id !== undefined
                ? '/?referrer_id=' + this.state.referrer_id
                : ''
        this.props.history.replace('/oktalogin' + path)
    }

    // on_forgot_password = () => this.props.history.replace('/reset_password')

    on_google_login = response => {
        let $this = this
        if (!response || !response.tokenObj) {
            return
        }

        $this.setState({ auth_loading: true })
        CloudFlyerAPI.user_account
            .loginOAuth({
                service: 'Google',
                token: response.tokenObj.id_token,
                email: response.profileObj.email,
                referrer_id: this.state.referrer_id,
            })
            .then(res => {
                $this.props.dispatch(
                    receiveData(LOGIN_SUCCESS, (res || {}).data || {})
                )
                $this.setState({ auth_loading: false })
            })
            .catch(err => {
                $this.setState({ auth_loading: false })
                console.error(err)
            })
    }

    setPanel = panel => {
        switch (panel) {
            case 'login':
                this.setState({
                    forgotPasswordVisible: false,
                    emailSentVisible: false,
                })
                break
            case 'forgotPassword':
                this.setState({
                    forgotPasswordVisible: true,
                    emailSentVisible: false,
                })
                break
            case 'resetEmailSent':
                this.setState({
                    forgotPasswordVisible: true,
                    emailSentVisible: true,
                })
                break
        }
    }

    sendResetEmail = async () => {
        const email = this.props.form.getFieldsValue().email
        if (email){
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let validEmail = re.test(String(email).toLowerCase());
            if (validEmail) {
                try{
                    this.setState({ sendingRequest: true })

                    const {data} = await CloudFlyerAPI.new_user_account.request_temp_token();

                    await CloudFlyerAPI.new_user_account.request_reset_password(email, data);

                    message.success('Email sent successfully, please check your email.')
                    
                    this.setState({ email, sendingRequest: false })
                    this.setPanel('resetEmailSent')
                } catch (err) {
                    message.error(err.message)
                    this.setState({ sendingRequest: false })
                }
            }else {
                message.error('Please enter a valid email.');
                }

                // this.setState({ sendingRequest: true })
                // CloudFlyerAPI.new_user_account
                //     .request_reset_password(email)
                //     .then(() => {
                //         message.success(
                //             'Email sent successfully, please check your email.'
                //         )
                //         this.setState({ email, sendingRequest: false })
                //         this.setPanel('resetEmailSent')
                //     })
                //     .catch(err => {
                //         message.error(err.message)
                //         this.setState({ sendingRequest: false })
                //     })
            // }
            // else{
            //     message.error('Please enter a valid email.');
            // }
        }
        else{
            message.error('Please enter an email.');
        }
    }


    render() {
        const { getFieldDecorator } = this.props.form
        const {
            referrer_id,
            auth_loading,
            forgotPasswordVisible,
            resetEmailSent,
            emailSentVisible,
            email,
            sendingRequest,
            mfaChallenge
        } = this.state
        // let google_client_id = window.GOOGLE_CLIENT_ID
        console.log(this.props.mfaChallenge)
        console.log(this.props.mfaSession)
        const loginFormPanel = (
            <div className="login-panel">
                <div className="wasabiLogo">
                    <img alt="wasabi Logo" src={wasabiDarkLogo} />
                </div>

                <div className="login-form-wrapper">
                    <Form
                    layout="horizontal"
                    className="login-form"
                    onSubmit={this.handleSubmit.bind(this)}
                    >
                        <h4 className="login-form-title">
                            Please login to your account
                        </h4>
                        <Form.Item>
                            {getFieldDecorator('user')(
                                <Input 
                                    placeholder="Username or Email Address"
                                    className="login-input"
                                />
                            )}
                        </Form.Item>
                        <Form.Item>
                            {getFieldDecorator('password')(
                                <Input 
                                    placeholder="Password"
                                    type="password"
                                    className="login-input"
                                />
                            )}
                        </Form.Item>
                        <a
                            className="forgot-password"
                            onClick={() => this.setPanel('forgotPassword')}>
                            Forgot Password?
                        </a>
                        {/* <div className="terms">
                            <Form.Item  name="policy" valuePropName="checked">
                                <Checkbox></Checkbox>
                            </Form.Item>
                            <Form.Item>
                                <p>I accept the Wasabi Bucket Replication Manager 
                                    <a
                                    target="_blank"
                                    href="/">
                                    Terms and Conditions
                                    </a>
                                </p>
                            </Form.Item>
                        </div> */}
                        <Form.Item>
                            <Button
                                className="btn-login"
                                type="primary"
                                size="large"
                                loading={this.state.loading}
                                htmlType="submit"
                                block>
                                Login
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
                
            </div>
        )

        const mfaFormPanel = (
            <div className="login-panel">
                <div className="wasabiLogo">
                    <img alt="wasabi Logo" src={wasabiDarkLogo} />
                </div>

                <div className="login-form-wrapper">
                    <Form
                    layout="horizontal"
                    className="login-form"
                    onSubmit={this.handleMFASubmit.bind(this)}
                    >
                        <h4 className="login-form-title">
                            Enter an MFA code to complete sign-in.
                        </h4>
                        <Form.Item>
                            {getFieldDecorator('mfacode')(
                                <Input 
                                    placeholder="MFA Code"
                                    className="login-input"
                                />
                            )}
                        </Form.Item>
                        <Form.Item>
                            <Button
                                className="btn-login"
                                type="primary"
                                size="large"
                                loading={this.state.loading}
                                htmlType="submit"
                                block>
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        )


        const forgotPasswordPanel = (
            <Spin spinning={sendingRequest}>
                <div className="forgot-password-panel">
                    <div className="forgot-password-form-box">
                        <div className="wasabiLogo">
                            <img alt="wasabi Logo" src={wasabiDarkLogo} />
                        </div>
                        <div className="forgot-password-wrapper">
                            <Form
                                layout="horizontal"
                                className="forgot-password-form"
                                onSubmit={e => {
                                    e.preventDefault()
                                    this.sendResetEmail()
                                }}
                            >
                                <p className="forget-password-title">
                                Enter the email address you signed up with below. An
                                email will be sent containing a link to reset your
                                password.
                                </p>
                                <Form.Item>
                                    {getFieldDecorator('email')(
                                        <Input
                                            className="reset-email"
                                            // type=""
                                            placeholder="Username or Email Address"
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item>
                                    <Button
                                        className="reset-btn"
                                        type="primary"
                                        size="large"
                                        htmlType="submit"
                                        block>
                                        Send Reset Link
                                    </Button>
                                </Form.Item>
                            </Form>
                            <a
                                className="reset-login"
                                onClick={() => this.setPanel('login')}>
                                Go back to Login
                            </a>
                        </div>
                    </div>
                </div>
            </Spin>
        )

        // const forgotPasswordPanel = (
        //     <Spin spinning={sendingRequest}>
        //         <div className="forgot-password-panel">
        //             <div className="enter-email-panel">
        //                 <h1 className="reset-title">
        //                     Reset Your Password
        //                 </h1>
        //                 <p className="reset-text">
        //                     Enter the email address you signed up with below. An
        //                     email will be sent containing a link to reset your
        //                     password.
        //                 </p>
        //                 <Form
        //                     onSubmit={e => {
        //                         e.preventDefault()
        //                         this.sendResetEmail()
        //                     }}>
        //                     <Form.Item>
        //                         {getFieldDecorator('email')(
        //                             <Input
        //                                 className="reset-email"
        //                                 type="email"
        //                                 placeholder="Email"
        //                             />
        //                         )}
        //                     </Form.Item>
        //                     <Form.Item>
        //                         <Button
        //                             className="reset-btn"
        //                             type="primary"
        //                             size="large"
        //                             htmlType="submit"
        //                             block>
        //                             Send Reset Link
        //                         </Button>
        //                     </Form.Item>
        //                 </Form>
        //             </div>
        //             <a
        //                 className="reset-login"
        //                 onClick={() => this.setPanel('login')}>
        //                 Login
        //             </a>
        //         </div>
        //     </Spin>
        // )

        const emailSentPanel = (
            <div className="email-sent-panel">
                <div className="email-sent-box">
                    <div className="email-sent-header">
                        <img alt="Sent email image" src={EnvelopeImg} />
                    </div>
                    <div className="email-sent-content">

                        <h1>We sent you a reset email</h1>
                        {/* <a>{email}</a> */}
                        <p>
                            Please check your email and use the reset link <br /> to
                            reset your password.
                        </p>
                        <div className="not-send-msg">
                            Didn't get the reset email ?{' '}
                            <a onClick={() => this.setPanel('forgotPassword')}>
                                resend email
                            </a>{' '}
                            or <a onClick={() => this.setPanel('login')}>login</a>
                        </div>
                    </div>
                </div>
            </div>
        )

        let contentBox
        if (!forgotPasswordVisible && !this.props.mfaChallenge) {
            contentBox = loginFormPanel
        } 
        else if (!forgotPasswordVisible && this.props.mfaChallenge) {
            contentBox = mfaFormPanel
        } 
        else if (emailSentVisible) {
            contentBox = emailSentPanel
        } 
        else {
            contentBox = forgotPasswordPanel
        }

        return (
            <div className="form-container">
                <div className="form-header">
                    <div className="logo">
                        <a href="/" target="_blank">
                            <img alt="wasabi logo" src={wasabiDarkLogo} />
                        </a>
                    </div>
                    {/* <div className="link">
                        <a onClick={this.toRegister}>Sign Up</a>
                    </div> */}
                </div>
                <div className="form-content">
                    <div className="content-box">{contentBox}</div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { auth } = state

    if (auth.user && localStorage.Authorization) {
        return { user: auth.user, loggingIn: auth.loggingIn, loginErrors: '' }
    }
    return {
        user: null,
        loading: auth.loading,
        loggingIn: auth.loggingIn,
        loginErrors: auth.loginErrors,
        mfaChallenge: auth.mfaChallenge,
        mfaSession: auth.mfaSession,
    }
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            // login,
            mfa_respond,
            new_login,
            refresh_profile,
            dispatch,
        },
        dispatch
    )

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Form.create()(Login))
)
